export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReEKR0JwYy1FVUMtSGEUoaIAhD8AAIQ+BgCEVgABvBgAAIRXBA2ERj4AvBqDIgCEQgYBhEQCAIQ9AQC8GwsBhEABALwcAQCEQxsAvB0BALweAQCEWBsAhFQBAIRVAAC8Hw==", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/GBpc-EUC-V.bcmap
// module id = 652
// module chunks = 502